/**
 * Fuzzy search utility for team names
 * @param {string} searchTerm - The search term to match against
 * @param {string} teamName - The team name to search in
 * @returns {boolean} - True if the search term matches the team name
 */
export function fuzzySearch(searchTerm, teamName) {
  if (!searchTerm || !teamName) return false;

  const normalizedSearch = searchTerm.toLowerCase().trim();
  const normalizedTeam = teamName.toLowerCase();

  // Direct substring match
  if (normalizedTeam.includes(normalizedSearch)) {
    return true;
  }

  // Split search term into words and check if all words are found
  const searchWords = normalizedSearch.split(/\s+/);
  return searchWords.every(word => normalizedTeam.includes(word));
}

/**
 * Filter games by team name search
 * @param {Array} games - Array of game objects
 * @param {string} searchTerm - The search term
 * @returns {Array} - Filtered games
 */
export function filterGamesByTeamSearch(games, searchTerm) {
  if (!searchTerm || !games) return games;

  return games.filter(game => {
    const awayTeamName = game.away_team?.name || '';
    const homeTeamName = game.home_team?.name || '';

    return fuzzySearch(searchTerm, awayTeamName) || fuzzySearch(searchTerm, homeTeamName);
  });
}
